import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  divInformationGeneral: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  textInformationGeneral: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  divInfos: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    "& > div": { flex: 1, minWidth: 0 },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },
  divInfos2: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  // Security actions (e.g. reset password), separated from the profile info.
  securityRow: {
    display: "flex",
    justifyContent: "flex-start",
    borderTop: `1px solid ${colors.borderLight}`,
    paddingTop: "12px",
    marginTop: "2px",
  },
});

export default useStyles;